import TemplateContents from './TemplateContents';
import TopHero from './TopHero';
import ProductsModal from './ProductsModal';
import FeaturePanel from './FeaturePanel';
import Statement from './Statement';
import BrandMovie from './BrandMovie';
import Feature from './Feature';
import Products from './Products';
import Yoku from './Yoku';

import { gsap } from 'gsap';

import lottie from 'lottie-web/build/player/lottie_svg';



export default class extends TemplateContents {
  constructor(param) {
    super(param);
  }

  init() {
    super.init();

    this.hero = new TopHero();
    this.featurePanel = new FeaturePanel();
    this.productsModal = this.pack.productsModal = new ProductsModal();
    this.statement = new Statement();
    this.statement.start();
    this.brandMovie = new BrandMovie();
    this.brandMovie.start();
    this.feature = new Feature();
    this.products = new Products();
    this.yoku = new Yoku();
    this.yoku.start();
    
    this.pack.common.addScrollTarget(this);
    this.pack.common.addEnterframeTarget(this);

    //冒頭でスクロールロック
    this.pack.common.lockScroll = true;
    if (this.sw < this.pack.BP) document.documentElement.classList.add('lock');
  }

  reset() {
    super.reset();

    this.setVars();
    this.pack.common.addScrollTarget(this);
    this.pack.common.addEnterframeTarget(this);
  }

  destruct() {
    super.destruct();

    this.pack.common.removeScrollTarget(this);
    this.pack.common.removeEnterframeTarget(this);
  }

  setVars() {
    super.setVars();
    this.section2Y = 0;
    this.section5Content1Y = 0;
    this.interSectionPos = [];
  }

  setDom() {
    super.setDom();

    this.heroFeatureBtn = document.querySelector('main.top .hero .feature');
    this.interSectionAll = document.querySelectorAll('main.top .intersection');
    this.interSectionIconAll = document.querySelectorAll('main.top .intersection .icon');
    this.section2 = document.querySelector('main.top .section2');
    this.section5Content1 = document.querySelector('main.top .section5 .content1');
  }

  initEvents() {
    super.initEvents();

    this.heroFeatureBtn.addEventListener('click', (event)=>{
      this.featurePanel.open();
    });

    // URLのハッシュが変更された時にも実行する（リロードされないケースへの対応）
    window.addEventListener('hashchange', () => {
      this.checkHash();
    });

    // アイコンのホバーアニメーション (PCのみ)
    if (!this.pack.hasTouch) {
      this.interSectionIconAll.forEach(icon => {
        icon.addEventListener('mouseenter', () => {
          if (gsap.isTweening(icon)) return;
          gsap.to(icon, {
            y: -25,
            duration: 0.3,
            ease: "back.out(1.7)"
          });
        });
        icon.addEventListener('mouseleave', () => {
          gsap.to(icon, {
            y: 0,
            duration: 0.4,
            ease: "bounce.out"
          });
        });
      });
    }
  }

  start() {
    // インターセクションのアイコン
    for( let i = 0, len = this.interSectionIconAll.length; i < len; i++ ){
      let icon = this.interSectionIconAll[i];
      const randomNum = Math.floor(Math.random() * 7) + 1;
      icon.classList.add(`color${randomNum}`);
    }
  }

  startIntro(){
    this.hero.start();
    gsap.delayedCall(1.5, ()=>{
      this.heroFeatureBtn.classList.add('show');
    });
    this.checkHash();
  }

  checkHash() {
    const hash = window.location.hash;
    let target;

    // ブラウザの自動ジャンプを防ぐため、HTML側の id="xxx" を data-id="xxx" に変更することを推奨
    // ここでは id と data-id の両方を探すように変更
    const targetId = hash.replace('#', '');
    if(targetId) target = document.querySelector(`#${targetId}`) || document.querySelector(`[data-id="${targetId}"]`);

    if (target) {
      gsap.delayedCall(1, () => {
        // 1秒待つ間にレイアウトが変わる可能性があるため、実行直前に座標を再計算する
        const rect = target.getBoundingClientRect();
        const scrollTop = this.pack.scrollY;
        const targetY = rect.top + scrollTop;

        if (this.pack.anchorScroll) this.pack.anchorScroll(targetY, 1.25);
      });
    }
  }


  scrollHandler() {
    this.brandMovie.scrollHandler();

    this.section2Y = this.section2.getBoundingClientRect().top;
    this.section5Content1Y = this.section5Content1.getBoundingClientRect().top;

    if(this.section2Y < 0 && this.section2Y >= -this.sh) {
      this.pack.header.changeGlobalNavColor();
    }else if(this.section2Y >= 0 && this.section2Y < this.sh) {
      this.pack.header.changeGlobalNavColor(true);
    }else if(this.section5Content1Y < 0) {
      this.pack.header.changeGlobalNavColor(true);
    }else if(this.section5Content1Y >= 0 && this.section5Content1Y < this.sh) {
      this.pack.header.changeGlobalNavColor();
    }

    // intersectionのアニメーション
    const scrollTop = this.pack.scrollY;
    if (this.interSectionPos && this.interSectionPos.length > 0) {
      this.interSectionAll.forEach((item, i) => {
        const baseTop = this.interSectionPos[i];
        // 画面中央に来た時を基準(0)として、スクロール量に応じて移動
        const diff = (scrollTop + this.sh / 2) - baseTop;
        const speed = (this.sw >= this.pack.BP) ? 0.15 : 0.08; // PCとSPで移動量を調整
        const direction = (i % 2 === 0) ? -1 : 1; // 偶数は左へ、奇数は右へ
        item.style.transform = `translate3d(${diff * speed * direction}px, 0, 0)`;
      });
    }
  }

  enterframe() {
    this.brandMovie.enterframe();
    this.yoku.enterframe();
    this.featurePanel.enterframe();
    this.feature.enterframe();
  }

  enterframeThinOut() {
    this.hero.enterframeThinOut();
    this.yoku.enterframeThinOut();
  }

  executeResize() {
    super.executeResize();

    // intersectionのY座標位置を取得（スクロール連動の基準点）
    this.interSectionPos = [];
    const scrollTop = this.pack.scrollY;
    this.interSectionAll.forEach((item) => {
      const rect = item.getBoundingClientRect();
      this.interSectionPos.push(rect.top + scrollTop);
    });
  }
}